import { AIChatHeader, AIChatHistory, AIChatInput, AIChatOutput, AIChatService } from '@nt-portal/doc-agent-sdk';
import { BaseClientService } from '../base-client.service';
import { FetchParams, ResultData } from '@nt-portal/common-sdk';
import { createUUID } from '../../../common';

export class ClientDocAIChatService extends BaseClientService {

    private _service: AIChatService;


    constructor() {
        super();
        this._service = new AIChatService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }


    public async chat(prompt: string, sessionId: string, tags?: string[], services?: string[]): Promise<AIChatOutput> {

        let chatInput: AIChatInput = {
            prompt: prompt,
            sessionId: sessionId,
            tags: tags,
            promptServices: services,
            promptId: createUUID()
        }
        return this._service.chatStream(this.token, chatInput);
    }

    /**
     * All the streaming responses will be sent via socket.io on the 'chat' event. 
     * The final response will be sent back via this method once the streaming is done. 
     * */
    public async chatStream(prompt: string, sessionId: string, promptId?: string, tags?: string[], services?: string[]): Promise<AIChatOutput> {

        let chatInput: AIChatInput = {
            prompt: prompt,
            sessionId: sessionId,
             tags: tags,
            promptServices: services,
            promptId: promptId ?? createUUID()
        }
        return this._service.chatStream(this.token, chatInput);
    }

    public async headers(fetchParams: FetchParams): Promise<ResultData<AIChatHeader>> {
        return this._service.headers(this.token, fetchParams);
    }

    public async history(sessionId: string): Promise<AIChatHistory[]> {
        return this._service.history(this.token, sessionId);
    }
}